import type { ReactNode } from "react";

export type ScreenIllustrationKind =
  | "seals"
  | "posts"
  | "journey"
  | "notifications"
  | "saved"
  | "integrations"
  | "security"
  | "calendar"
  | "analytics"
  | "billing"
  | "support"
  | "courses"
  | "certificates"
  | "team"
  | "planning";

// Cenas decorativas no mesmo traço da LearningPathIllustration.
// Sem cores fixas, texto, IDs ou movimento: podem coexistir e herdar o white label.
const scenes: Record<ScreenIllustrationKind, ReactNode> = {
  courses: (
    <>
      <g transform="rotate(-9 188 169)">
        <rect
          x="111"
          y="96"
          width="151"
          height="153"
          rx="16"
          fill="var(--background)"
          stroke="var(--foreground)"
          strokeOpacity=".4"
          strokeWidth="3"
        />
        <path
          d="M133 127H218M133 143H194M133 218H172"
          stroke="var(--foreground)"
          strokeOpacity=".25"
          strokeWidth="5"
        />
        <rect
          x="132"
          y="162"
          width="108"
          height="33"
          rx="7"
          fill="var(--primary)"
          fillOpacity=".1"
          stroke="none"
        />
        <path d="M146 178H188" stroke="var(--primary)" strokeOpacity=".6" strokeWidth="4" />
      </g>
      <path
        d="M109 290H280V316H109A13 13 0 0 1 109 290Z"
        fill="var(--background)"
        stroke="var(--foreground)"
        strokeOpacity=".4"
        strokeWidth="3"
      />
      <path
        d="M122 264H295V290H122A13 13 0 0 1 122 264Z"
        fill="var(--background)"
        stroke="var(--foreground)"
        strokeOpacity=".4"
        strokeWidth="3"
      />
      <path d="M124 264H295V290H124Z" fill="var(--primary)" fillOpacity=".1" stroke="none" />
      <path d="M113 303H207M126 277H224" stroke="var(--foreground)" strokeOpacity=".18" />
      <rect
        x="235"
        y="144"
        width="251"
        height="194"
        rx="19"
        fill="var(--background)"
        stroke="var(--foreground)"
        strokeOpacity=".4"
        strokeWidth="3"
      />
      <rect
        x="250"
        y="159"
        width="221"
        height="121"
        rx="11"
        fill="var(--primary)"
        fillOpacity=".1"
        stroke="none"
      />
      <circle cx="361" cy="219" r="31" fill="var(--primary)" stroke="none" />
      <path d="M353 205L375 219L353 233Z" fill="var(--primary-foreground)" stroke="none" />
      <path d="M260 301H432" stroke="var(--foreground)" strokeOpacity=".18" strokeWidth="5" />
      <path d="M260 301H323" stroke="var(--primary)" strokeWidth="5" />
      <path
        d="M260 319H325M414 319H453"
        stroke="var(--foreground)"
        strokeOpacity=".25"
        strokeWidth="4"
      />
      <g transform="rotate(9 410 99)">
        <rect
          x="372"
          y="68"
          width="76"
          height="61"
          rx="12"
          fill="var(--background)"
          stroke="var(--primary)"
          strokeOpacity=".6"
        />
        <path d="M392 98L404 110L427 87" stroke="var(--primary)" strokeWidth="4" />
      </g>
    </>
  ),
  certificates: (
    <>
      <g transform="rotate(7 302 213)">
        <rect
          x="148"
          y="107"
          width="307"
          height="207"
          rx="14"
          fill="var(--background)"
          stroke="var(--foreground)"
          strokeOpacity=".22"
        />
        <rect
          x="163"
          y="122"
          width="277"
          height="177"
          rx="7"
          fill="var(--primary)"
          fillOpacity=".06"
          stroke="none"
        />
      </g>
      <g transform="rotate(-6 272 223)">
        <rect
          x="116"
          y="126"
          width="313"
          height="205"
          rx="14"
          fill="var(--background)"
          stroke="var(--foreground)"
          strokeOpacity=".4"
          strokeWidth="3"
        />
        <path
          d="M136 171V147H161M383 147H408V171M136 284V309H161M383 309H408V284"
          stroke="var(--primary)"
          strokeOpacity=".65"
          strokeWidth="3"
        />
        <path d="M207 179H338" stroke="var(--primary)" strokeOpacity=".6" strokeWidth="6" />
        <path
          d="M163 209H382M182 229H363M213 250H332"
          stroke="var(--foreground)"
          strokeOpacity=".25"
          strokeWidth="5"
        />
        <path
          d="M166 289H222M168 282L181 270L189 282L202 272L214 281"
          stroke="var(--foreground)"
          strokeOpacity=".3"
        />
      </g>
      <path
        d="M368 282L351 355L376 342L392 365L409 294M409 294L428 358L446 336L472 345L450 278"
        fill="var(--primary)"
        fillOpacity=".12"
        stroke="var(--primary)"
        strokeOpacity=".65"
      />
      <path
        d="M408 208L425 219L445 220L453 238L469 251L466 271L470 291L454 304L446 322L426 323L409 334L392 323L372 322L364 304L348 291L352 271L349 251L365 238L373 220L393 219Z"
        fill="var(--background)"
        stroke="var(--primary)"
        strokeOpacity=".65"
        strokeWidth="3"
      />
      <circle cx="409" cy="271" r="42" fill="var(--primary)" fillOpacity=".12" stroke="none" />
      <path
        d="M409 244L417 261L436 264L422 277L425 296L409 287L393 296L396 277L382 264L401 261Z"
        fill="var(--primary)"
        fillOpacity=".18"
        stroke="var(--primary)"
        strokeWidth="3"
      />
      <path
        d="M138 94L144 80M177 87V71M468 185L482 175"
        stroke="var(--primary)"
        strokeOpacity=".5"
        strokeWidth="3"
      />
    </>
  ),
  team: (
    <>
      <path
        d="M165 236V285Q165 306 186 306H299M442 251V285Q442 306 421 306H301"
        stroke="var(--primary)"
        strokeOpacity=".6"
        strokeWidth="3"
        strokeDasharray="6 9"
      />
      <g transform="rotate(-9 168 172)">
        <rect
          x="106"
          y="91"
          width="124"
          height="164"
          rx="17"
          fill="var(--background)"
          stroke="var(--foreground)"
          strokeOpacity=".4"
          strokeWidth="3"
        />
        <circle
          cx="168"
          cy="139"
          r="23"
          fill="var(--primary)"
          fillOpacity=".12"
          stroke="var(--primary)"
          strokeOpacity=".65"
        />
        <path
          d="M133 194V188A35 35 0 0 1 203 188V194Z"
          fill="var(--primary)"
          fillOpacity=".1"
          stroke="var(--foreground)"
          strokeOpacity=".25"
        />
        <path
          d="M140 220H196M150 233H186"
          stroke="var(--foreground)"
          strokeOpacity=".25"
          strokeWidth="4"
        />
      </g>
      <g transform="rotate(9 433 184)">
        <rect
          x="371"
          y="103"
          width="124"
          height="164"
          rx="17"
          fill="var(--background)"
          stroke="var(--foreground)"
          strokeOpacity=".4"
          strokeWidth="3"
        />
        <circle
          cx="433"
          cy="151"
          r="23"
          fill="var(--primary)"
          fillOpacity=".12"
          stroke="var(--primary)"
          strokeOpacity=".65"
        />
        <path
          d="M398 206V200A35 35 0 0 1 468 200V206Z"
          fill="var(--primary)"
          fillOpacity=".1"
          stroke="var(--foreground)"
          strokeOpacity=".25"
        />
        <path
          d="M405 232H461M415 245H451"
          stroke="var(--foreground)"
          strokeOpacity=".25"
          strokeWidth="4"
        />
      </g>
      <rect
        x="221"
        y="159"
        width="158"
        height="188"
        rx="19"
        fill="var(--background)"
        stroke="var(--foreground)"
        strokeOpacity=".4"
        strokeWidth="3"
      />
      <rect
        x="234"
        y="172"
        width="132"
        height="117"
        rx="12"
        fill="var(--primary)"
        fillOpacity=".08"
        stroke="none"
      />
      <circle
        cx="300"
        cy="210"
        r="26"
        fill="var(--background)"
        stroke="var(--primary)"
        strokeWidth="3"
      />
      <path
        d="M261 272V267A39 39 0 0 1 339 267V272Z"
        fill="var(--background)"
        stroke="var(--primary)"
        strokeWidth="3"
      />
      <path
        d="M253 312H347M270 328H330"
        stroke="var(--foreground)"
        strokeOpacity=".25"
        strokeWidth="5"
      />
      <path
        d="M263 104H337M283 95H317"
        stroke="var(--primary)"
        strokeOpacity=".45"
        strokeWidth="4"
      />
      <circle cx="300" cy="133" r="5" fill="var(--primary)" stroke="none" />
    </>
  ),
  planning: (
    <>
      <g transform="rotate(-8 232 218)">
        <rect
          x="130"
          y="104"
          width="205"
          height="233"
          rx="18"
          fill="var(--background)"
          stroke="var(--foreground)"
          strokeOpacity=".4"
          strokeWidth="3"
        />
        <rect
          x="191"
          y="90"
          width="83"
          height="28"
          rx="9"
          fill="var(--background)"
          stroke="var(--primary)"
          strokeOpacity=".65"
          strokeWidth="3"
        />
        <path
          d="M167 145H263M167 159H228"
          stroke="var(--foreground)"
          strokeOpacity=".25"
          strokeWidth="5"
        />
        <rect
          x="162"
          y="186"
          width="25"
          height="25"
          rx="6"
          fill="var(--primary)"
          fillOpacity=".12"
          stroke="var(--primary)"
          strokeOpacity=".65"
        />
        <path d="M168 198L174 204L183 192" stroke="var(--primary)" strokeWidth="3" />
        <rect
          x="162"
          y="230"
          width="25"
          height="25"
          rx="6"
          fill="var(--background)"
          stroke="var(--foreground)"
          strokeOpacity=".25"
        />
        <rect
          x="162"
          y="274"
          width="25"
          height="25"
          rx="6"
          fill="var(--background)"
          stroke="var(--foreground)"
          strokeOpacity=".25"
        />
        <path
          d="M205 198H296M205 242H278M205 286H287"
          stroke="var(--foreground)"
          strokeOpacity=".25"
          strokeWidth="5"
        />
      </g>
      <circle
        cx="395"
        cy="234"
        r="88"
        fill="var(--background)"
        stroke="var(--foreground)"
        strokeOpacity=".4"
        strokeWidth="3"
      />
      <circle
        cx="395"
        cy="234"
        r="67"
        fill="var(--primary)"
        fillOpacity=".08"
        stroke="var(--primary)"
        strokeOpacity=".45"
      />
      <circle
        cx="395"
        cy="234"
        r="44"
        fill="var(--background)"
        stroke="var(--primary)"
        strokeOpacity=".65"
      />
      <circle
        cx="395"
        cy="234"
        r="20"
        fill="var(--primary)"
        fillOpacity=".18"
        stroke="var(--primary)"
      />
      <path d="M395 234L455 153" stroke="var(--primary)" strokeWidth="4" />
      <path
        d="M439 174L438 147L468 120L465 149L485 143L461 176Z"
        fill="var(--background)"
        stroke="var(--primary)"
        strokeWidth="3"
      />
      <path d="M456 153L468 137" stroke="var(--primary)" strokeWidth="3" />
      <path
        d="M365 344H423M383 358H405"
        stroke="var(--primary)"
        strokeOpacity=".45"
        strokeWidth="4"
      />
    </>
  ),
  calendar: (
    <>
      <g transform="rotate(-8 261 217)">
        <rect
          x="125"
          y="103"
          width="272"
          height="234"
          rx="20"
          fill="var(--background)"
          stroke="var(--foreground)"
          strokeOpacity=".4"
          strokeWidth="3"
        />
        <path
          d="M126 159V123A19 19 0 0 1 145 104H377A19 19 0 0 1 396 123V159Z"
          fill="var(--primary)"
          fillOpacity=".12"
          stroke="none"
        />
        <path d="M126 159H396" stroke="var(--foreground)" strokeOpacity=".22" />
        <path d="M184 88V121M338 88V121" stroke="var(--primary)" strokeWidth="6" />
        <g stroke="var(--foreground)" strokeOpacity=".25" strokeWidth="7">
          <path d="M162 192H176M219 192H233M276 192H290M333 192H347" />
          <path d="M162 240H176M219 240H233M333 240H347" />
          <path d="M162 288H176M219 288H233M276 288H290" />
        </g>
        <rect x="262" y="220" width="42" height="40" rx="10" fill="var(--primary)" stroke="none" />
        <path d="M273 240L280 247L294 232" stroke="var(--primary-foreground)" strokeWidth="3" />
      </g>
      <circle
        cx="411"
        cy="284"
        r="65"
        fill="var(--background)"
        stroke="var(--foreground)"
        strokeOpacity=".4"
        strokeWidth="3"
      />
      <circle cx="411" cy="284" r="51" fill="var(--primary)" fillOpacity=".09" stroke="none" />
      <path d="M411 251V284L433 297" stroke="var(--primary)" strokeWidth="4" />
      <circle cx="411" cy="284" r="4" fill="var(--primary)" stroke="none" />
      <path
        d="M427 135L443 119M441 155H462M412 122V106"
        stroke="var(--primary)"
        strokeOpacity=".5"
        strokeWidth="3"
      />
    </>
  ),
  analytics: (
    <>
      <g transform="rotate(-7 211 155)">
        <rect
          x="112"
          y="91"
          width="179"
          height="128"
          rx="16"
          fill="var(--background)"
          stroke="var(--foreground)"
          strokeOpacity=".22"
        />
        <circle
          cx="165"
          cy="151"
          r="31"
          stroke="var(--primary)"
          strokeOpacity=".15"
          strokeWidth="12"
        />
        <path d="M165 120A31 31 0 0 1 192 166" stroke="var(--primary)" strokeWidth="12" />
        <path
          d="M218 137H263M218 153H252M218 169H242"
          stroke="var(--foreground)"
          strokeOpacity=".25"
          strokeWidth="5"
        />
      </g>
      <rect
        x="177"
        y="168"
        width="290"
        height="180"
        rx="18"
        fill="var(--background)"
        stroke="var(--foreground)"
        strokeOpacity=".4"
        strokeWidth="3"
      />
      <path
        d="M202 198H277M202 211H247"
        stroke="var(--foreground)"
        strokeOpacity=".25"
        strokeWidth="5"
      />
      <path
        d="M207 319H438M207 274H438M207 230H438"
        stroke="var(--foreground)"
        strokeOpacity=".1"
      />
      <path
        d="M226 319V284H257V319M280 319V261H311V319M334 319V242H365V319M388 319V219H419V319"
        fill="var(--primary)"
        fillOpacity=".12"
        stroke="none"
      />
      <path d="M226 273L295 245L349 225L418 191" stroke="var(--primary)" strokeWidth="3" />
      <g fill="var(--background)" stroke="var(--primary)" strokeWidth="3">
        <circle cx="226" cy="273" r="5" />
        <circle cx="295" cy="245" r="5" />
        <circle cx="349" cy="225" r="5" />
        <circle cx="418" cy="191" r="5" />
      </g>
      <path
        d="M375 112H441V147L426 136H375A12 12 0 0 1 363 124A12 12 0 0 1 375 112Z"
        fill="var(--background)"
        stroke="var(--primary)"
        strokeOpacity=".6"
      />
      <path
        d="M379 127L390 117L400 127L420 108M410 108H420V118"
        stroke="var(--primary)"
        strokeWidth="3"
      />
    </>
  ),
  billing: (
    <>
      <g transform="rotate(-9 239 216)">
        <path
          d="M149 93H329A14 14 0 0 1 343 107V340L324 329L305 340L286 329L267 340L248 329L229 340L210 329L191 340L172 329L153 340L135 329V107A14 14 0 0 1 149 93Z"
          fill="var(--background)"
          stroke="var(--foreground)"
          strokeOpacity=".4"
          strokeWidth="3"
        />
        <rect
          x="159"
          y="117"
          width="160"
          height="49"
          rx="9"
          fill="var(--primary)"
          fillOpacity=".1"
          stroke="none"
        />
        <path
          d="M177 141H232M275 141H300"
          stroke="var(--primary)"
          strokeOpacity=".6"
          strokeWidth="4"
        />
        <path
          d="M160 194H249M285 194H318M160 219H232M285 219H318M160 244H245M285 244H318"
          stroke="var(--foreground)"
          strokeOpacity=".25"
          strokeWidth="5"
        />
        <path
          d="M160 268H318"
          stroke="var(--foreground)"
          strokeOpacity=".22"
          strokeDasharray="4 7"
        />
        <path d="M160 293H211M269 293H318" stroke="var(--primary)" strokeWidth="5" />
      </g>
      <g transform="rotate(8 386 269)">
        <rect
          x="285"
          y="206"
          width="199"
          height="126"
          rx="17"
          fill="var(--background)"
          stroke="var(--foreground)"
          strokeOpacity=".4"
          strokeWidth="3"
        />
        <rect
          x="286"
          y="229"
          width="197"
          height="25"
          fill="var(--primary)"
          fillOpacity=".15"
          stroke="none"
        />
        <rect
          x="307"
          y="275"
          width="31"
          height="23"
          rx="5"
          fill="var(--primary)"
          fillOpacity=".16"
          stroke="var(--primary)"
          strokeOpacity=".6"
        />
        <path
          d="M307 309H355M431 309H457"
          stroke="var(--foreground)"
          strokeOpacity=".25"
          strokeWidth="4"
        />
      </g>
      <path
        d="M393 133L403 150L393 167L383 150ZM393 119A31 31 0 1 0 393 181A31 31 0 0 0 393 119Z"
        stroke="var(--primary)"
        strokeOpacity=".65"
        strokeWidth="3"
      />
    </>
  ),
  support: (
    <>
      <g transform="rotate(-8 212 181)">
        <path
          d="M128 102H296A18 18 0 0 1 314 120V226A18 18 0 0 1 296 244H197L158 275V244H128A18 18 0 0 1 110 226V120A18 18 0 0 1 128 102Z"
          fill="var(--background)"
          stroke="var(--foreground)"
          strokeOpacity=".4"
          strokeWidth="3"
        />
        <path
          d="M137 138H270M137 157H245M137 211H192"
          stroke="var(--foreground)"
          strokeOpacity=".25"
          strokeWidth="5"
        />
        <path d="M137 184H272" stroke="var(--primary)" strokeOpacity=".45" strokeWidth="5" />
      </g>
      <rect
        x="259"
        y="173"
        width="217"
        height="172"
        rx="22"
        fill="var(--background)"
        stroke="var(--foreground)"
        strokeOpacity=".4"
        strokeWidth="3"
      />
      <rect
        x="274"
        y="188"
        width="187"
        height="112"
        rx="13"
        fill="var(--primary)"
        fillOpacity=".08"
        stroke="none"
      />
      <path d="M328 250V237A39 39 0 0 1 406 237V250" stroke="var(--primary)" strokeWidth="4" />
      <rect
        x="318"
        y="240"
        width="20"
        height="34"
        rx="8"
        fill="var(--background)"
        stroke="var(--primary)"
        strokeWidth="3"
      />
      <rect
        x="396"
        y="240"
        width="20"
        height="34"
        rx="8"
        fill="var(--background)"
        stroke="var(--primary)"
        strokeWidth="3"
      />
      <path d="M406 275V278A11 11 0 0 1 395 289H377" stroke="var(--primary)" strokeWidth="3" />
      <path
        d="M301 322H369M398 322H435"
        stroke="var(--foreground)"
        strokeOpacity=".25"
        strokeWidth="5"
      />
      <path
        d="M401 100H448A14 14 0 0 1 462 114V143A14 14 0 0 1 448 157H426L410 171V157H401A14 14 0 0 1 387 143V114A14 14 0 0 1 401 100Z"
        fill="var(--background)"
        stroke="var(--primary)"
        strokeOpacity=".65"
      />
      <g fill="var(--primary)" stroke="none">
        <circle cx="409" cy="129" r="3" />
        <circle cx="425" cy="129" r="3" />
        <circle cx="441" cy="129" r="3" />
      </g>
    </>
  ),
  seals: (
    <>
      <g transform="rotate(-12 300 218)">
        <path
          d="M241 252L212 346L254 329L278 362L303 274M301 274L326 362L350 329L392 346L363 252"
          fill="var(--primary)"
          fillOpacity=".09"
          stroke="var(--primary)"
          strokeOpacity=".75"
        />
        <path
          d="M300 92L325 105L353 104L372 125L398 136L404 164L421 187L413 214L415 243L394 262L382 288L354 294L331 311L304 303L275 305L256 284L230 272L224 244L207 221L215 194L213 165L234 146L246 120L274 114Z"
          fill="var(--background)"
          stroke="var(--foreground)"
          strokeOpacity=".4"
          strokeWidth="3"
        />
        <circle cx="313" cy="202" r="82" fill="var(--primary)" fillOpacity=".12" stroke="none" />
        <circle cx="313" cy="202" r="66" stroke="var(--primary)" strokeOpacity=".6" />
        <path
          d="M313 158L326 185L356 189L334 210L339 240L313 226L287 240L292 210L270 189L300 185Z"
          fill="var(--primary)"
          fillOpacity=".14"
          stroke="var(--primary)"
          strokeWidth="3"
        />
      </g>
      <path
        d="M151 164L161 145M427 108L444 95M452 206H472M149 283L165 276"
        stroke="var(--primary)"
        strokeOpacity=".45"
        strokeWidth="3"
      />
      <circle cx="185" cy="106" r="8" stroke="var(--foreground)" strokeOpacity=".2" />
      <circle cx="441" cy="298" r="5" fill="var(--primary)" fillOpacity=".3" stroke="none" />
    </>
  ),
  posts: (
    <>
      <g transform="rotate(-9 238 220)">
        <rect
          x="120"
          y="107"
          width="224"
          height="218"
          rx="18"
          fill="var(--background)"
          stroke="var(--foreground)"
          strokeOpacity=".4"
          strokeWidth="3"
        />
        <path
          d="M146 136H256M146 155H218M146 276H224"
          stroke="var(--foreground)"
          strokeOpacity=".3"
          strokeWidth="5"
        />
        <rect
          x="145"
          y="179"
          width="174"
          height="71"
          rx="10"
          fill="var(--primary)"
          fillOpacity=".12"
          stroke="none"
        />
      </g>
      <rect
        x="221"
        y="140"
        width="236"
        height="201"
        rx="18"
        fill="var(--background)"
        stroke="var(--foreground)"
        strokeOpacity=".4"
        strokeWidth="3"
      />
      <circle cx="259" cy="178" r="13" fill="var(--primary)" fillOpacity=".16" stroke="none" />
      <path
        d="M286 173H385M286 185H346M247 220H428M247 240H405M247 260H360"
        stroke="var(--foreground)"
        strokeOpacity=".3"
        strokeWidth="5"
      />
      <path d="M247 305H286" stroke="var(--primary)" strokeOpacity=".45" strokeWidth="4" />
      <path
        d="M381 83H464A18 18 0 0 1 482 101V151A18 18 0 0 1 464 169H421L398 190V169H381A18 18 0 0 1 363 151V101A18 18 0 0 1 381 83Z"
        fill="var(--background)"
        stroke="var(--primary)"
        strokeOpacity=".65"
      />
      <path d="M390 126H453M421 105V147" stroke="var(--primary)" strokeWidth="3" />
      <path
        d="M157 327L166 336L185 316"
        stroke="var(--primary)"
        strokeOpacity=".5"
        strokeWidth="3"
      />
    </>
  ),
  journey: (
    <>
      <path d="M92 340H508" stroke="var(--foreground)" strokeOpacity=".22" />
      <path
        d="M112 314C98 248 235 296 228 218S340 230 358 150S450 107 470 82"
        stroke="var(--primary)"
        strokeWidth="3"
        strokeDasharray="7 10"
      />
      <path
        d="M100 343V292H199V343M199 343V239H303V343M303 343V180H409V343M409 343V128H496V343"
        fill="var(--background)"
        stroke="var(--foreground)"
        strokeOpacity=".22"
      />
      <path
        d="M101 293H198V342H101ZM200 240H302V342H200ZM304 181H408V342H304ZM410 129H495V342H410Z"
        fill="var(--primary)"
        fillOpacity=".07"
        stroke="none"
      />
      <circle cx="149" cy="278" r="17" fill="var(--primary)" stroke="none" />
      <path d="M142 278L147 283L157 272" stroke="var(--primary-foreground)" strokeWidth="3" />
      <circle cx="250" cy="225" r="17" fill="var(--primary)" stroke="none" />
      <path d="M243 225L248 230L258 219" stroke="var(--primary-foreground)" strokeWidth="3" />
      <circle
        cx="355"
        cy="166"
        r="17"
        fill="var(--background)"
        stroke="var(--primary)"
        strokeWidth="3"
      />
      <circle cx="355" cy="166" r="5" fill="var(--primary)" stroke="none" />
      <path d="M451 128V58L495 71L451 88" stroke="var(--primary)" strokeWidth="3" />
      <path d="M452 59L495 71L452 88Z" fill="var(--primary)" fillOpacity=".14" stroke="none" />
      <g transform="rotate(-10 155 150)">
        <rect
          x="106"
          y="95"
          width="98"
          height="105"
          rx="12"
          fill="var(--background)"
          stroke="var(--foreground)"
          strokeOpacity=".22"
        />
        <path
          d="M126 122H183M126 136H171M126 174H153"
          stroke="var(--foreground)"
          strokeOpacity=".18"
          strokeWidth="4"
        />
        <path d="M126 153H176" stroke="var(--primary)" strokeWidth="4" />
      </g>
    </>
  ),
  notifications: (
    <>
      <g transform="rotate(-7 197 226)">
        <rect
          x="103"
          y="125"
          width="239"
          height="194"
          rx="18"
          fill="var(--background)"
          stroke="var(--foreground)"
          strokeOpacity=".22"
        />
        <circle cx="137" cy="160" r="12" fill="var(--primary)" fillOpacity=".12" stroke="none" />
        <path
          d="M162 154H257M162 166H216M127 200H301M127 218H278M127 237H244M127 286H182"
          stroke="var(--foreground)"
          strokeOpacity=".16"
          strokeWidth="5"
        />
        <path d="M127 263H265" stroke="var(--primary)" strokeOpacity=".35" strokeWidth="5" />
      </g>
      <rect
        x="290"
        y="74"
        width="184"
        height="221"
        rx="24"
        fill="var(--background)"
        stroke="var(--foreground)"
        strokeOpacity=".22"
      />
      <rect
        x="305"
        y="89"
        width="154"
        height="150"
        rx="15"
        fill="var(--primary)"
        fillOpacity=".08"
        stroke="none"
      />
      <path
        d="M338 205C351 190 350 179 350 156A32 32 0 0 1 414 156C414 179 413 190 426 205Z"
        fill="var(--background)"
        stroke="var(--primary)"
        strokeWidth="3"
      />
      <path
        d="M371 215C372 229 392 229 394 215M382 116V106"
        stroke="var(--primary)"
        strokeWidth="3"
      />
      <path
        d="M345 262H419M363 276H401"
        stroke="var(--foreground)"
        strokeOpacity=".18"
        strokeWidth="5"
      />
      <path
        d="M325 143L316 135M438 143L447 135M322 164H312M442 164H452"
        stroke="var(--primary)"
        strokeOpacity=".5"
      />
      <circle
        cx="461"
        cy="86"
        r="23"
        fill="var(--primary)"
        stroke="var(--background)"
        strokeWidth="5"
      />
      <path d="M452 86L459 93L471 79" stroke="var(--primary-foreground)" strokeWidth="3" />
    </>
  ),
  saved: (
    <>
      <path
        d="M123 299L108 137A14 14 0 0 1 122 122H280L301 313"
        fill="var(--background)"
        stroke="var(--foreground)"
        strokeOpacity=".22"
      />
      <path
        d="M141 130L150 98A14 14 0 0 1 167 88L378 133L339 318"
        fill="var(--primary)"
        fillOpacity=".08"
        stroke="var(--foreground)"
        strokeOpacity=".22"
      />
      <g transform="rotate(7 345 210)">
        <rect
          x="245"
          y="91"
          width="188"
          height="229"
          rx="14"
          fill="var(--background)"
          stroke="var(--foreground)"
          strokeOpacity=".22"
        />
        <rect
          x="264"
          y="112"
          width="150"
          height="89"
          rx="8"
          fill="var(--primary)"
          fillOpacity=".09"
          stroke="none"
        />
        <path
          d="M280 182L313 148L338 170L359 151L397 182"
          stroke="var(--primary)"
          strokeOpacity=".5"
        />
        <circle cx="381" cy="133" r="8" fill="var(--primary)" fillOpacity=".3" stroke="none" />
        <path
          d="M266 225H398M266 243H381M266 261H349"
          stroke="var(--foreground)"
          strokeOpacity=".16"
          strokeWidth="5"
        />
        <path d="M365 91H399V151L382 140L365 151Z" fill="var(--primary)" stroke="none" />
      </g>
      <path
        d="M101 265A14 14 0 0 1 115 251H214L236 274H470L452 339A16 16 0 0 1 437 351H128A16 16 0 0 1 112 337Z"
        fill="var(--background)"
        stroke="var(--foreground)"
        strokeOpacity=".22"
      />
      <path
        d="M102 265A14 14 0 0 1 115 251H214L236 274H470L452 339A16 16 0 0 1 437 351H128A16 16 0 0 1 112 337Z"
        fill="var(--primary)"
        fillOpacity=".09"
        stroke="none"
      />
      <path d="M143 322H207" stroke="var(--primary)" strokeWidth="4" />
    </>
  ),
  integrations: (
    <>
      <path
        d="M162 162H226Q245 162 245 181V244Q245 263 264 263H322M381 248V177Q381 158 400 158H442"
        stroke="var(--primary)"
        strokeWidth="3"
        strokeDasharray="7 9"
      />
      <rect
        x="83"
        y="99"
        width="111"
        height="112"
        rx="18"
        fill="var(--background)"
        stroke="var(--foreground)"
        strokeOpacity=".22"
      />
      <rect
        x="317"
        y="217"
        width="134"
        height="108"
        rx="18"
        fill="var(--background)"
        stroke="var(--foreground)"
        strokeOpacity=".22"
      />
      <rect
        x="429"
        y="104"
        width="80"
        height="86"
        rx="14"
        fill="var(--background)"
        stroke="var(--foreground)"
        strokeOpacity=".22"
      />
      <path
        d="M105 126H171M105 142H145M339 297H412M448 169H490"
        stroke="var(--foreground)"
        strokeOpacity=".16"
        strokeWidth="5"
      />
      <path
        d="M124 164L113 176L124 188M154 164L165 176L154 188M144 161L134 191"
        stroke="var(--primary)"
        strokeWidth="3"
      />
      <path
        d="M365 242V252M401 242V252M356 252H410V263A27 27 0 0 1 356 263ZM383 290V305"
        fill="var(--primary)"
        fillOpacity=".12"
        stroke="var(--primary)"
        strokeWidth="3"
      />
      <circle cx="469" cy="139" r="14" fill="var(--primary)" fillOpacity=".12" stroke="none" />
      <path d="M463 139L467 143L476 134" stroke="var(--primary)" strokeWidth="3" />
      <circle
        cx="245"
        cy="209"
        r="7"
        fill="var(--primary)"
        stroke="var(--background)"
        strokeWidth="3"
      />
      <circle
        cx="381"
        cy="192"
        r="7"
        fill="var(--primary)"
        stroke="var(--background)"
        strokeWidth="3"
      />
      <path
        d="M140 245V298Q140 317 159 317H271"
        stroke="var(--foreground)"
        strokeOpacity=".22"
        strokeDasharray="4 8"
      />
    </>
  ),
  security: (
    <>
      <g transform="rotate(-8 203 213)">
        <rect
          x="112"
          y="111"
          width="185"
          height="216"
          rx="18"
          fill="var(--background)"
          stroke="var(--foreground)"
          strokeOpacity=".22"
        />
        <path
          d="M137 142H270M137 158H219"
          stroke="var(--foreground)"
          strokeOpacity=".16"
          strokeWidth="5"
        />
        <rect
          x="134"
          y="195"
          width="140"
          height="43"
          rx="8"
          fill="var(--primary)"
          fillOpacity=".08"
          stroke="var(--foreground)"
          strokeOpacity=".22"
        />
        <g fill="var(--primary)" stroke="none">
          <circle cx="156" cy="217" r="4" />
          <circle cx="174" cy="217" r="4" />
          <circle cx="192" cy="217" r="4" />
          <circle cx="210" cy="217" r="4" />
        </g>
        <path
          d="M137 268H243M137 285H210"
          stroke="var(--foreground)"
          strokeOpacity=".16"
          strokeWidth="5"
        />
      </g>
      <path
        d="M381 98C408 118 435 125 464 130V221C464 276 423 310 381 331C339 310 298 276 298 221V130C327 125 354 118 381 98Z"
        fill="var(--background)"
        stroke="var(--foreground)"
        strokeOpacity=".22"
      />
      <path
        d="M381 119C403 134 423 140 445 145V219C445 261 414 290 381 309C348 290 317 261 317 219V145C339 140 359 134 381 119Z"
        fill="var(--primary)"
        fillOpacity=".09"
        stroke="none"
      />
      <path d="M359 202V183A22 22 0 0 1 403 183V202" stroke="var(--primary)" strokeWidth="4" />
      <rect x="345" y="201" width="72" height="61" rx="12" fill="var(--primary)" stroke="none" />
      <circle cx="381" cy="225" r="6" fill="var(--primary-foreground)" stroke="none" />
      <path d="M381 230V240" stroke="var(--primary-foreground)" strokeWidth="4" />
      <path d="M464 302L471 309L486 293" stroke="var(--primary)" strokeWidth="3" />
    </>
  ),
};

export function ScreenIllustration({
  kind,
  className,
}: {
  kind: ScreenIllustrationKind;
  className?: string;
}) {
  return (
    <svg
      viewBox="0 0 600 440"
      fill="none"
      aria-hidden="true"
      focusable="false"
      className={className}
    >
      <ellipse cx="300" cy="374" rx="212" ry="24" fill="var(--foreground)" opacity=".04" />
      <circle
        cx="300"
        cy="214"
        r="170"
        fill="var(--primary)"
        fillOpacity=".025"
        stroke="var(--foreground)"
        strokeOpacity=".22"
      />
      <circle
        cx="300"
        cy="214"
        r="135"
        stroke="var(--foreground)"
        strokeOpacity=".22"
        strokeDasharray="3 10"
      />
      <g strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        {scenes[kind]}
        <path
          d="M76 99V115M68 107H84M503 337V349M497 343H509"
          stroke="var(--primary)"
          strokeOpacity=".5"
        />
        <circle cx="258" cy="55" r="4" stroke="var(--primary)" strokeOpacity=".5" />
      </g>
    </svg>
  );
}
